module.exports = __webpack_public_path__ + "img/公告.8eb0a256.svg";